import PropTypes from 'prop-types';
import EcommerceDeepLinkButton from './EcommerceDeepLinkButton';
import EcommerceMessageButton from './EcommerceMessageButton';
import EcommercePhoneButton from './EcommercePhoneButton';
import { DATA_LAYER_OPTIONS, ECOMMERCE_BUTTON_SIZES, MESSAGE_TYPES } from '../../constants';
import { buildTransactionId, pushPurchase } from '../../utils/data-layer';
import { extractListingDataLayerData } from '../../utils/transformers';

const EcommerceButtons = ({
  brokerDeepLinks,
  contacts,
  data,
  size,
  yachtData,
  buttonText,
  modifier
}) => {
  const phoneContacts = contacts.filter(contact => contact.phone);
  const brokerLogos = {};

  const handleClickOnBrokerLogo = contact => {
    const dataLayerPayload = extractListingDataLayerData(yachtData, contacts);

    const personalizedPayload = {
      ...dataLayerPayload,
      brokerIds: contact.brokerId,
      brokerNames: contact.brokerName
    };

    const transactionId = buildTransactionId(yachtData.id);
    pushPurchase(personalizedPayload, DATA_LAYER_OPTIONS.WEBSITE, transactionId);
  };

  const contactsFiltered = contacts
    .map((contact, i) => {
      const imageUrl = (contact.image || {}).url;
      if (!imageUrl) return null;

      if (brokerLogos[imageUrl]) return null;
      brokerLogos[imageUrl] = true;

      const imageAlt = ((contact.image || {}).data || {}).alt;

      return { website: contact.website, imageUrl, imageAlt, data: contact };
    })
    .filter(contact => !!contact);

  return (
    <div className={`ecommerce__buttons ecommerce__buttons--size-${size} ${modifier}`}>
      {size === ECOMMERCE_BUTTON_SIZES.SIDEBAR && (
        <>
          <h2 className="ecommerce__buttons__disclaimer">{`Listed for ${data.listingType} by`}</h2>

          <div
            className={`ecommerce__buttons__logos ecommerce__buttons__logos--multi-${
              contactsFiltered.length > 1 ? 'true' : 'false'
            }`}>
            {contactsFiltered.map((contact, i) => (
              <a
                href={contact.website}
                key={i}
                onClick={() => handleClickOnBrokerLogo(contact.data)}
                className="image__wrapper"
                target="_blank"
                rel="noreferrer">
                <img src={contact.imageUrl} alt={contact.imageAlt} className="image" />
              </a>
            ))}
          </div>

          <div className="ecommerce__buttons__wrapper">
            {phoneContacts.length > 0 && (
              <EcommercePhoneButton contacts={phoneContacts} disableClicks yachtData={yachtData} />
            )}

            <EcommerceMessageButton
              contacts={contacts}
              disableClicks
              messageType={MESSAGE_TYPES.GENERAL}
              yachtData={yachtData}
              size={size}
            />

            {brokerDeepLinks.length > 0 && (
              <EcommerceDeepLinkButton
                brokerDeepLinks={brokerDeepLinks}
                contacts={contacts}
                disableClicks
                yachtData={yachtData}
              />
            )}
          </div>
        </>
      )}

      {size === ECOMMERCE_BUTTON_SIZES.SIDEBAR_CHARTER && (
        <>
          <h2 className="ecommerce__buttons__disclaimer">{`Listed for ${data.listingType} by`}</h2>

          <div
            className={`ecommerce__buttons__logos ecommerce__buttons__logos--multi-${
              contactsFiltered.length > 1 ? 'true' : 'false'
            }`}>
            {contactsFiltered.map((contact, i) => (
              <a
                href={contact.website}
                key={i}
                onClick={() => handleClickOnBrokerLogo(contact.data)}
                className="image__wrapper"
                target="_blank"
                rel="noreferrer">
                <img src={contact.imageUrl} alt={contact.imageAlt} className="image" />
              </a>
            ))}
          </div>

          <div className="ecommerce__buttons__wrapper">
            {phoneContacts.length > 0 && (
              <EcommercePhoneButton contacts={phoneContacts} yachtData={yachtData} />
            )}

            <EcommerceMessageButton
              contacts={contacts}
              messageType={MESSAGE_TYPES.GENERAL}
              yachtData={yachtData}
              size={size}
            />

            {brokerDeepLinks.length > 0 && (
              <EcommerceDeepLinkButton
                brokerDeepLinks={brokerDeepLinks}
                contacts={contacts}
                yachtData={yachtData}
              />
            )}
          </div>
        </>
      )}

      {size === ECOMMERCE_BUTTON_SIZES.CONTACT_AND_REQUEST_CALL && (
        <>
          <h2 className="ecommerce__buttons__disclaimer">Contact broker</h2>

          <div className="ecommerce__buttons__wrapper">
            <EcommerceMessageButton
              contacts={contacts}
              messageType={MESSAGE_TYPES.GENERAL}
              yachtData={yachtData}
              size={size}
            />

            {phoneContacts.length > 0 && (
              <EcommercePhoneButton contacts={phoneContacts} yachtData={yachtData} />
            )}

            <EcommerceMessageButton
              contacts={contacts}
              messageType={MESSAGE_TYPES.CALL_BACK}
              yachtData={yachtData}
              size={size}
            />
          </div>
        </>
      )}

      {size === ECOMMERCE_BUTTON_SIZES.CONTACT_AND_REQUEST_CALL_MOBILE && (
        <div className="ecommerce__buttons__wrapper">
          <EcommerceMessageButton
            contacts={contacts}
            disableClicks
            messageType={MESSAGE_TYPES.GENERAL}
            yachtData={yachtData}
            size={size}
          />

          {phoneContacts.length > 0 && (
            <EcommercePhoneButton contacts={phoneContacts} disableClicks yachtData={yachtData} />
          )}

          <EcommerceMessageButton
            contacts={contacts}
            disableClicks
            messageType={MESSAGE_TYPES.CALL_BACK}
            yachtData={yachtData}
            size={size}
          />
        </div>
      )}

      {size === ECOMMERCE_BUTTON_SIZES.SPECS_AND_DECKPLANS && (
        <>
          <EcommerceMessageButton
            contacts={contacts}
            messageType={MESSAGE_TYPES.FULL_SPECS}
            yachtData={yachtData}
            size={size}
          />

          <EcommerceMessageButton
            contacts={contacts}
            messageType={MESSAGE_TYPES.DECKPLANS}
            yachtData={yachtData}
            size={size}
          />

          <EcommerceMessageButton
            contacts={contacts}
            messageType={MESSAGE_TYPES.BROCHURE}
            yachtData={yachtData}
            size={size}
          />
        </>
      )}

      {size === ECOMMERCE_BUTTON_SIZES.MESSAGE && (
        <EcommerceMessageButton
          contacts={contacts}
          messageType={MESSAGE_TYPES.MESSAGE}
          yachtData={yachtData}
          size={size}
          buttonText={buttonText}
        />
      )}
    </div>
  );
};

EcommerceButtons.propTypes = {
  brokerDeepLinks: PropTypes.array,
  contacts: PropTypes.array.isRequired,
  data: PropTypes.object.isRequired,
  size: PropTypes.string.isRequired,
  yachtData: PropTypes.object,
  buttonText: PropTypes.string,
  modifier: PropTypes.string
};

EcommerceButtons.defaultProps = {
  brokerDeepLinks: [],
  buttonText: '',
  modifier: ''
};

export default EcommerceButtons;
